import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../../redux/actions'
import autobind from 'react-autobind'
import {
  Link, Redirect,
  withRouter
} from 'react-router-dom';
import _ from 'lodash'
import ProductBoxListItem from './../../components/Product/ProductBoxListItem';
import StatisticsTiles from './../../components/Statistics/StatisticsTiles';
import Footer from './../../components/Footer';
import Header from './../../components/Header';
import Subheader from './../../components/Subheader';
import Dialog from './../../components/Dialog/Dialog';
import Pagination, { ITEMS_PER_PAGE } from './../../components/Pagination/Pagination'
import FilterSorter from './../../components/FilterSorter';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import QRCode from 'react-qr-code'
import { qrCodeProxyURLProduct } from "../../lib/data";
import ConversionsDialog from './../../components/Dialog/ConversionsDialog';
import { store } from '../../index';

const sortFuncGen = (property, direction) => {
  const up = direction === "asc" ? 1 : -1
    , down = direction === "asc" ? -1 : 1
  return ((a, b) => a[property] < b[property] || !a[property] ? down : up)
}

class ProductsDomainPage extends PureComponent {

  constructor(props) {
    super(props);
    autobind(this);

    const mappedDomain = this.mapDomainConstant(this.props.match.params.domain);

    this.state = {
      disabled: false,
      domain: mappedDomain,
      domainId: this.getDomainIdByConstant(mappedDomain),
      filteredProducts: [],
      products: [],
      showViewInARModal: false,
      viewInARModalProductName: '',
      currentProductIDQRCode: null,
      conversionsDialogOpen: false
    }

    this.sortbyItems = [
      { name: "Create Date (asc)", sortFunc: sortFuncGen("createdAt", "asc"), onSelect: this.sortby },
      { name: "Create Date (desc)", sortFunc: sortFuncGen("createdAt", "desc"), onSelect: this.sortby },
    ]

    this.filterByItems = [
      { name: "All", filterFunc: (i) => true, onSelect: this.filterby },
      { name: "Published", filterFunc: (i) => i.published, onSelect: this.filterby },
      { name: "Unpublished", filterFunc: (i) => !i.published, onSelect: this.filterby },
      { name: "Featured", filterFunc: (i) => i.featured, onSelect: this.filterby },
    ]

  }

  componentDidMount() {
    this.props.getProducts()
    this.props.getUserStatistics()
  }

  componentWillReceiveProps(props) {
    if (props.location.search === '?reload=true') {
      window.location.reload();
    }

    const { allProducts, filterByIndex, sortByIndex, query, conversionsBefore } = props
      , products = allProducts || []
      , disabled = false

    this.setState({
      products,
      filteredProducts: this._filterProducts(products, query, filterByIndex, sortByIndex),
      disabled,
      conversionsDialogOpen: !!conversionsBefore
    })
  }

  getDomainIdByConstant(constant) {
    const { user } = this.props;
    let domainId = null;
    _.each(user.domain, (domain) => {
      if (domain.constant === constant) {
        domainId = domain._id
      }
    })
    return domainId
  }

  mapDomainConstant(domain) {
    switch (domain) {
      case 'furniture':
        return 'FURNITURE';
      case 'real-estate':
        return 'REAL_ESTATE';
      case 'home-deco':
        return 'HOME_DECO';
      case 'all':
        return 'FURNITURE';
      default:
        return 'FURNITURE';
    }
  }

  publishProduct(productId) {
    this.props.publishProduct(productId);
  }

  unPublishProduct(productId) {
    this.props.unPublishProduct(productId);
  }

  editProduct(productId) {
    this.props.history.push('/products/' + productId);
  }

  viewInARProduct(productId) {
    this.setState({
      currentProductIDQRCode: productId
    })
    this.toggleViewInARModal();
  }


  isSubscriptionDisabled(isPayed, expirationDate) {
    const currentDate = new Date();
    const expireDate = new Date(expirationDate)
    const isExpired = currentDate.getTime() > expireDate.getTime()

    return !isPayed || isExpired
  }

  confirmDeleteModalProceed() {
    if (this.props.toDeleteProductId) {
      this.props.deleteProduct(this.props.toDeleteProductId);
    }
  }

  onConversionsDialogClose() {
    this.props.setConversionsBefore(null);
  }

  toggleAllowDownload(productId) {
    this.props.toggleCTA(productId, 'download')
  }

  toggleAllowFavourite(productId) {
    this.props.toggleCTA(productId, 'favourite')
  }

  toggleFeatured(productId) {
    this.props.toggleCTA(productId, 'featured')
  }

  toggleAllowShare(productId) {
    this.props.toggleCTA(productId, 'share')
  }
  toggleViewInARModal() {
    this.setState({
      showViewInARModal: !this.state.showViewInARModal
    })
  }

  getDomainName() {
    switch (this.state.domain) {
      case 'FURNITURE':
        return 'Furniture';
      case 'HOME_DECO':
        return 'Home deco'
      case 'REAL_ESTATE':
        return 'Real estate'
      default: break;
    }
    return null
  }

  _filterProducts(products, searchKeyword, filterByIndex, sortByIndex) {

    const searchFilterFunc = searchKeyword.length < 3 ? p => true : p => new RegExp(searchKeyword, 'gi').test(p.name)
    return products.slice(0)
      .sort(this.sortbyItems[sortByIndex].sortFunc)
      .filter(searchFilterFunc)
      .filter(this.filterByItems[filterByIndex].filterFunc)
  }

  onSearch(searchKeyword) {
    const { products } = this.state;
    const { filterByIndex, sortByIndex, productsPaginateDataChanged } = this.props;
    this.setState({
      filteredProducts: this._filterProducts(products, searchKeyword, filterByIndex, sortByIndex)
    });
    productsPaginateDataChanged({ query: searchKeyword });
  }

  sortby(sortByIndex) {
    const { products } = this.state;
    const { productsPaginateDataChanged, filterByIndex, query } = this.props;
    this.setState({
      filteredProducts: this._filterProducts(products, query, filterByIndex, sortByIndex)
    });
    productsPaginateDataChanged({ sortByIndex });
  }

  paginateProducts(products) {
    const { currentPage } = this.props;
    const from = currentPage * ITEMS_PER_PAGE
    const to = from + ITEMS_PER_PAGE

    return products.slice(from, to)
  }

  updatePage(e, currentPage) {
    e.preventDefault();

    const { productsPaginateDataChanged } = this.props;
    productsPaginateDataChanged({ currentPage });
  }

  filterby(filterByIndex) {
    const { products } = this.state;
    const { productsPaginateDataChanged, sortByIndex, query } = this.props;

    this.setState({
      filteredProducts: this._filterProducts(products, query, filterByIndex, sortByIndex)
    });
    productsPaginateDataChanged({ filterByIndex });
  }

  toggle(target) {
    const field = `dropdownOpen${target}`
    this.setState({ [field]: !this.state[field] })
  }
  render() {
    const { user, role } = this.props;
    const userBlocked = store.getState().userStatus.userBlocked;
    if (3 === role) {
      return <Redirect to="/s/dashboard" />
    }

    if (!user) {
      return <Redirect to="/login" />
    }

    const { statistics, sortByIndex, currentPage, query, conversionsBefore } = this.props
      , { products, filteredProducts } = this.state
    let productList = [];

    if (products) {
      productList = filteredProducts.map((product, index) => {

        return <ProductBoxListItem
          index={index + 1}
          key={product._id}
          impersonating={this.props.impersonating}
          productId={product._id}
          imagePath={product.productPath}
          title={product.name}
          price={product.price}
          currency={product.currency}
          tags={product.tag}
          views={product.views}
          featured={product.featured} toggleFeatured={this.toggleFeatured}
          disabled={this.state.disabled}
          allowDownload={product.allowDownload} toggleAllowDownload={this.toggleAllowDownload}
          allowFavourite={product.allowFavourite} toggleAllowFavourite={this.toggleAllowFavourite}
          allowShare={product.allowShare} toggleAllowShare={this.toggleAllowShare}
          publishProduct={this.publishProduct}
          unPublishProduct={this.unPublishProduct}
          editProduct={this.editProduct}
          viewInARProduct={this.viewInARProduct}
          deleteProduct={this.props.openDeleteProductModal} />
      });
    }
    const paginatedProducts = this.paginateProducts(productList);

    return <div>
      <Header />
      <Subheader search={true} breadcrumbs={[{ title: "Product Gallery", link: "/products" }]} onSearch={this.onSearch} searchValue={query} />
      <div className="stastistics-subheader">
        <div className="container mb-5">
          <StatisticsTiles statistics={statistics} products={statistics && statistics[0] ? statistics[0].products : null} />
        </div>
      </div>
      <div className="container mt-5">
        <div className="row product-general-wrapper no-gutter">
          <div className="col-10 items-list-filters align-items-center justify-content-between">

            <h4 className="mb-0 pl-4">Your Product Gallery</h4>
            <FilterSorter options={
              [
                {
                  type: "dropdown",
                  name: "sortby",
                  title: "Sort by",
                  selectedIndex: sortByIndex,
                  items: this.sortbyItems,
                  isOpen: this.state[`dropdownOpensortby`],
                  toggle: () => this.toggle('sortby')
                }
              ]
            } />
          </div>
          <div className="col-2 align-items-right no-gutters">
            <Link to="/products-new">
              <button className="btn btn-lg btn-primary btn-fill" disabled={userBlocked}>
                <i className="icon icon-left s7-plus"></i>
                Add new Product
                    </button>
            </Link>
          </div>
        </div>
        <div className="row no-gutter mt-4 product-gallery-list">
          {productList.length ? paginatedProducts : <p>No products found.</p>}
        </div>
        <Pagination currentPage={currentPage} itemsCount={productList.length} onClick={(e, page) => { this.updatePage(e, page) }} />
        <Dialog open={this.props.confirmDeleteModalOpen} proceed={this.confirmDeleteModalProceed} cancel={this.props.closeDeleteProductModal} message="If you delete this product you won't be able to retrieve the data." />
      </div>
      <Modal isOpen={this.state.showViewInARModal} toggle={this.toggleViewInARModal} className={`modal-s ${this.props.user.role === 3 ? "superadmin" : ""}`}>
        <ModalHeader>
          <span onClick={this.toggleViewInARModal} className="s7-close modal-close"></span>
        </ModalHeader>
        <ModalBody className="pt-0">
          <div className="row xs-gutters">
            <div className="col-12 text-center">
              <h3>Product</h3>
            </div>
            <div className="col-12 text-center mt-3">
              <p>Please scan this QR code with your mobile device camera to open the IndexAR app and preview your product:</p>
            </div>
            <div className="col-12 text-center mt-5 text-center">
              <QRCode value={qrCodeProxyURLProduct + this.state.currentProductIDQRCode} />
            </div>
            <div className="col-12 text-center text-center p-5">
              <a href={qrCodeProxyURLProduct + this.state.currentProductIDQRCode} target="_blank">
                {qrCodeProxyURLProduct + this.state.currentProductIDQRCode}
              </a>
            </div>
          </div>

        </ModalBody>
      </Modal>

      <ConversionsDialog
        open={this.state.conversionsDialogOpen}
        cancel={this.onConversionsDialogClose}
        conversionsBefore={conversionsBefore}
        email={user.email}
      />
      <Footer /></div>;
  }

}

export default connect(
  (state, ownProps) => {
    const {
      auth: { user, impersonating },
      products: { requestingDomainConstantProducts, all, error, productPaginateData, conversionsBefore, toDeleteProductId, confirmDeleteModalOpen },
      userStatus: { subscriptions },
      statistics: { statistics, currentMonthStatistics }
    } = state;
    const { sortByIndex, filterByIndex, currentPage, query } = productPaginateData;

    return {
      ...ownProps,
      user, impersonating,
      allProducts: all, requestingDomainConstantProducts, error,
      subscriptions,
      statistics, currentMonthStatistics,
      sortByIndex, filterByIndex, currentPage, query,
      conversionsBefore,
      toDeleteProductId, confirmDeleteModalOpen
    }
  },
  actions,
  (stateProps, dispatchProps) => {
    return Object.assign({}, stateProps, dispatchProps)
  }
)(withRouter(ProductsDomainPage))



// WEBPACK FOOTER //
// ./src/containers/Product/ProductsDomain.js